import type { ContentRequiredPageId } from '../page-registry';
import type { PageContent } from '../schema';
import { aboutPageContent } from './about';
import { contactPageContent } from './contact';
import { homePageContent } from './home';
import { journeyPageContent } from './journey';
import { weddingGiftingPageContent } from './weddingGifting';

export const pages = {
  home: homePageContent,
  about: aboutPageContent,
  contact: contactPageContent,
  journey: journeyPageContent,
  'wedding-gifting': weddingGiftingPageContent,
} satisfies Record<ContentRequiredPageId, PageContent>;
